import React from 'react';
import StatusPageLayout from '../components/StatusPageLayout';
import peepGrimacingSrc from '../images/peep-grimacing.svg';

const NoAccessView = () => (
	<StatusPageLayout
		pageTitle='Protected page'
		imageSrc={peepGrimacingSrc}
		title='You are not authorized to view this page'
		description='The author may have removed it.'
	/>
);

export default NoAccessView;
